import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updatePatient } from "../actions/patientActions";
import Message from "./Message";
import Loader from "./Loader";
import PatientPhone from "./PatientPhone";
import { deletePatient } from "../actions/patientActions";
import { useNavigate } from "react-router-dom";
import { PATIENT_DELETE_RESET } from "../constants/patientConstants";
import { notify } from "./notify";
import { Howl } from "howler";
import PatientTagForm from "./PatientTagForm";
import TextEditor from "./TextEditor";
import { FaPlusCircle, FaSyncAlt, FaTrash } from "react-icons/fa";
import genderTypes from "../data/genderTypes";

const PatientDetailsForm = ({
  patientId,
  setEditPatientDetails,
  isPhysician,
  patientVehicle,
  currentAge,
}) => {
  const [firstName, setFirstName] = useState(patientVehicle.firstName || "");
  const [secondName, setSecondName] = useState(patientVehicle.secondName || "");
  const [thirdName, setThirdName] = useState(patientVehicle.thirdName || "");
  const [fourthName, setFourthName] = useState(patientVehicle.fourthName || "");
  const [birthdate, setBirthdate] = useState(patientVehicle.birthdate || "");
  const [phones, setPhones] = useState(patientVehicle.phones || []);
  const [note, setNote] = useState(patientVehicle.note || "");
  const [gender, setGender] = useState(patientVehicle.gender || "");
  const [patientTags, setPatientTags] = useState(
    patientVehicle.patientTags.length > 0
      ? patientVehicle.patientTags
      : [
          {
            idx: Math.random(),
            label: "",
          },
        ],
  );

  const patientDetails = useSelector((state) => state.patientDetails);
  const { loading, error, patient } = patientDetails;

  const patientUpdateStore = useSelector((state) => state.patientUpdateStore);
  const {
    loading: loadingUpdate,
    updatedPatient,
    error: updateErr,
  } = patientUpdateStore;

  const visitsOfPatientStore = useSelector(
    (state) => state.visitsOfPatientStore,
  );
  const { patientVisits } = visitsOfPatientStore;

  const patientDeleteStore = useSelector((state) => state.patientDeleteStore);
  const { message } = patientDeleteStore;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { clinic } = clinicDetails;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const removePatient = () => {
    if (patientVisits && patientVisits.length > 0) {
      notify({
        title: "Patient Delete",
        message: (
          <p className="lead">
            Patient already had visit.
            <br /> Kindly, delete visit below firstly.
          </p>
        ),
        type: "danger",
        duration: 4000,
      });
    } else {
      if (window.confirm("are you sure?")) {
        dispatch(deletePatient(patient._id));
        dispatch({ type: PATIENT_DELETE_RESET });
        notify({
          title: "Delete Patient Success",
          message: <p className="lead">{message}</p>,
          type: "success",
          duration: 3000,
        });
        var sound = new Howl({
          src: `/success.mp3`,
        });
        sound.play();
        navigate(
          `/patient-list-screen/${clinic.adminId}?clinicId=${clinic._id}`,
        );
      }
    }
  };

  const addPatientTag = () => {
    setPatientTags([
      ...patientTags,
      {
        idx: Math.random(),
        label: "",
      },
    ]);
  };

  const deletePatientTag = (tag) => {
    if (window.confirm("You will delete this tag. Are you sure?")) {
      if (tag._id) {
        setPatientTags(
          patientTags.filter((vt) => vt._id.toString() !== tag._id.toString()),
        );
      } else {
        setPatientTags(
          patientTags.filter((vt) => vt.idx.toString() !== tag.idx.toString()),
        );
      }
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      updatePatient({
        patientId,
        firstName,
        secondName,
        thirdName,
        fourthName,
        birthdate,
        note,
        gender,
        patientTags: patientTags
          .filter((t) => t.tagId || t.label) //to avoid empty row
          .map((t) => {
            return {
              tagId: t.tagId && t.tagId,
              tagLabel: t.label && t.label,
              comment: t.comment,
            };
          }),
        phones: phones.map((p) => {
          return {
            phone: p.phone,
            whatsapp: p.whatsapp,
          };
        }),
      }),
    );
  };

  const addPhone = () => {
    setPhones([
      ...phones,
      {
        phone: "",
        whatsapp: false,
      },
    ]);
  };

  const deletePhone = (p) => {
    if (window.confirm("are you sure?")) {
      setPhones(phones.filter((ph) => ph._id !== p._id));
    }
  };

  // to jumb instead of typing space
  const goNext = (e) => {
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 1] && form.elements[index + 1].focus();
  };
  const onKeyDownSpace = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      goNext(e);
    }
  };
  const onInputSpace = (e) => {
    const v = e.target.value;
    if (v.endsWith(" ")) {
      e.target.value = v.trim();
      goNext(e);
    }
  };

  useEffect(() => {
    if (updatedPatient) {
      //check if new tags added without tagId update clinic details to get new tags
      if (patientTags.filter((t) => !t.tagId).length > 0) {
        dispatch({ type: "CLINIC_DETAILS_RESET" });
      }

      setEditPatientDetails(false);
      notify({
        title: "Patient Update Success",
        message: <p className="lead">Patient updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    }
  }, [updatedPatient]);
  return (
    <Col className="my-3 col-sm-12">
      {loading || loadingUpdate ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <Form onSubmit={submitHandler} className="mb-5">
          <Row className="justify-content-center mr-2 pb-2">
            <p>اسم المريض رباعي</p>{" "}
          </Row>
          <Row className="flex-row-reverse">
            <Form.Group controlId="firstName" className=" col-sm-3">
              <Form.Control
                type="name"
                className="text-center"
                placeholder="اسم المريض"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={firstName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="secondName" className="col-sm-3">
              <Form.Control
                type="name"
                className="text-center"
                placeholder="الاسم الأب"
                value={secondName}
                onChange={(e) => setSecondName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={secondName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="thirdName" className="col-sm-3">
              <Form.Control
                type="name"
                className="text-center"
                placeholder="اسم الجد"
                value={thirdName}
                onChange={(e) => setThirdName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={thirdName}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="fourthName" className="col-sm-3">
              <Form.Control
                type="name"
                className="text-center"
                placeholder="الاسم الرابع"
                value={fourthName}
                onChange={(e) => setFourthName(e.target.value)}
                onKeyDown={onKeyDownSpace}
                onInput={onInputSpace}
                isValid={fourthName}
              ></Form.Control>
            </Form.Group>
          </Row>
          <Form.Group controlId="birthdate" className="text-center">
            <Form.Label>تاريخ الميلاد</Form.Label>
            <Form.Control
              className="text-center"
              type="date"
              value={birthdate?.substring(0, 10)}
              onChange={(e) => setBirthdate(e.target.value)}
              isValid={birthdate}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="gender" className="text-center">
            <Form.Label>Gender | النوع</Form.Label>
            <Form.Control
              as="select"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              className="custom-select text-center"
              isValid={gender !== ""}
            >
              {genderTypes.map((g) => (
                <option key={g._id} value={g._id} disabled={g.disabled}>
                  {g.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Alert variant="info" className="mt-1 text-center">
            {currentAge &&
              `Age now is: ${currentAge.years} years, ${currentAge.months} months and ${currentAge.days}
               days`}
          </Alert>
          <Row className="form-label justify-content-center mr-2 pb-2">
            أرقام الهواتف
          </Row>
          {phones.map((p, order = 0) => (
            <div key={order + 1}>
              <PatientPhone phoneObj={p} deletePhone={deletePhone} />
            </div>
          ))}
          <Row className="justify-content-center">
            <Col
              xs="auto" // Ensures the column's width is only as wide as its content
              className="text-center" // Centers the content inside the column
              onClick={() => addPhone()}
            >
              إضافة رقم <FaPlusCircle />
            </Col>
          </Row>
          <hr className="border border-warning" />
          <Row className="text-center">
            <Col>
              <h2>ملاحظات</h2>
            </Col>
          </Row>
          <TextEditor text={note} setText={setNote} />
          <hr className="border border-warning" />
          {isPhysician && (
            <>
              <h2>Past Medical History</h2>
              {patientTags?.map((t) => (
                <div key={t._id || t.idx}>
                  <PatientTagForm tag={t} deleteTag={deletePatientTag} />
                </div>
              ))}
              <Row className="m-3" onClick={() => addPatientTag()}>
                <Col className="btn w-100 btn-secondary p-2">
                  <FaPlusCircle /> Add New Hx
                </Col>
              </Row>
            </>
          )}
          {updateErr && (
            <Row>
              <Message variant="danger" children={updateErr} />
            </Row>
          )}
          <Row>
            <Col className="col-md-6">
              <Button
                className="btn btn-danger"
                style={{ float: "left" }}
                onClick={() => removePatient()}
              >
                <FaTrash /> Delete Patient
              </Button>
            </Col>
            <Col className="col-md-6">
              <Button
                className="btn btn-primary"
                style={{ float: "right" }}
                type="submit"
              >
                <FaSyncAlt /> Update Details
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <hr style={{ backgroundColor: "blue" }} />
    </Col>
  );
};

export default PatientDetailsForm;
